import React from 'react'
import TextField from '@mui/material/TextField'

export default function BetBuilder() {
    const [stake, setStake] = React.useState(0);

    const handleChange = (event) => {
        setStake(event.target.value);
    };
    const handleBlur = () => {
        console.log('blur');
    };
    return (
        <div className='betbuilder'>
            <TextField
                id="outlined-basic"
                label="Stake readonly"
                value={stake}
                onChange={handleChange}
                onFocus={handleBlur}
                disabled
            />
            <TextField
                id="outlined-basic"
                label="Stake normal"
                value={stake}
                onChange={handleChange}
                onFocus={handleBlur}

            />
        </div>
    )
}
